import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-signup_modal_sell_as_brand-click';
/**
 * This event tracks when the &quot;Sign up to sell on Faire&quot; is clicked on the sign up modal
 */
export function trackSignupSignupModalSellAsBrandClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
